
export default {
  name: 'PageShopIndex',

  head() {
    return {
      title: 'Paw Paddock Shop',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Grab the latest merch from Paw Paddock'
        }
      ]
    }
  },

  created() {
    this.$redirect.to('/')
  }
}
